import { useQuery } from "@tanstack/react-query";

import { FETCH_ERROR } from "../consts/fetch-error";
import { getPropertyPart, getPropertyParts } from "../services/property-part";

export function useGetPropertyParts() {
  return useQuery({
    queryKey: ["propertyParts"],
    queryFn: () => getPropertyParts(),
    staleTime: 1000 * 60 * 60,
    retry: (_failureCount, error: unknown) =>
      error !== FETCH_ERROR.UNAUTHORIZED,
  });
}

export function useGetPropertyPart(id: string) {
  return useQuery({
    queryKey: ["propertyPart", id],
    queryFn: () => getPropertyPart(id),
    retry: (_failureCount, error: unknown) =>
      error !== FETCH_ERROR.UNAUTHORIZED,
  });
}
